import React from "react";
import { useNavigate } from "react-router-dom";

const PropertyFooter = () => {
  const slugify = (str) =>
    str
      .toLowerCase()
      .replace(/\s+/g, "-")
      .replace(/[^\w-]+/g, "");
  const navigate = useNavigate();
  return (
    <div className="bg-[#0B002A] py-12 ">
      <div className="md:mx-16 mx-6 text-white">
        <h1 className="font-semibold mb-3">Popular Searches</h1>
        <div className="grid grid-cols-1 xl:grid-cols-4 md:grid-cols-2 xl:gap-10 sm:gap-5 ">
          <div className="tracking-wide">
            <ul className="space-y-2 text-[#EEEEEE] text-sm">
              <li
                className="hover:text-blue-400 cursor-pointer"
                onClick={() => navigate(`/${slugify("SHAHID NAGAR")}`)}
              >
                Boys PG in Shaheed Nagar
              </li>
              <li
                className="hover:text-blue-400 cursor-pointer"
                onClick={() => navigate(`/${slugify("PATIA")}`)}
              >
                Girls PG in Patia
              </li>
              <li
                className="hover:text-blue-400 cursor-pointer"
                onClick={() => navigate(`/${slugify("KIIT SQUARE")}`)}
              >
                Boys PG in KIIT Square
              </li>
              <li
                className="hover:text-blue-400 cursor-pointer"
                onClick={() => navigate(`/${slugify("NAYAPALLI")}`)}
              >
                PG In Nayapalli
              </li>
            </ul>
          </div>

          <div className="tracking-wide">
            <ul className="space-y-2 text-[#EEEEEE] text-sm">
              <li
                className="hover:text-blue-400 cursor-pointer"
                onClick={() => navigate(`/${slugify("PATIA")}`)}
              >
                Boys PG in Patia
              </li>
              <li
                className="hover:text-blue-400 cursor-pointer"
                onClick={() => navigate(`/${slugify("KIIT SQUARE")}`)}
              >
                Girls PG in KIIT Square
              </li>
              <li
                className="hover:text-blue-400 cursor-pointer"
                onClick={() => navigate(`/${slugify("SHAHID NAGAR")}`)}
              >
                Girls PG in Shaheed Nagar
              </li>
              <li
                className="hover:text-blue-400 cursor-pointer"
                onClick={() => navigate(`/${slugify("NAYAPALLI")}`)}
              >
                Hostels In Nayapalli
              </li>
            </ul>
          </div>

          <div className="tracking-wide">
            <ul className="space-y-2 text-[#EEEEEE] text-sm">
              <li
                className="hover:text-blue-400 cursor-pointer"
                onClick={() => navigate(`/${slugify("NAYAPALLI")}`)}
              >
                Boys PG In Nayapalli
              </li>
              <li
                className="hover:text-blue-400 cursor-pointer"
                onClick={() => navigate(`/${slugify("JAYDEV VIHAR")}`)}
              >
                Hostel in Jaydev Vihar
              </li>
              <li
                className="hover:text-blue-400 cursor-pointer"
                onClick={() => navigate(`/${slugify("KIIT SQUARE")}`)}
              >
                Stay in KIIT Square
              </li>
              <li
                className="hover:text-blue-400 cursor-pointer"
                onClick={() => navigate(`/${slugify("PATIA")}`)}
              >
                PG in Patia
              </li>
            </ul>
          </div>

          <div className="tracking-wide">
            <ul className="space-y-2 text-[#EEEEEE] text-sm">
              <li
                className="hover:text-blue-400 cursor-pointer"
                onClick={() => navigate(`/${slugify("JAYDEV VIHAR")}`)}
              >
                Boys PG in Jaydev Vihar
              </li>
              <li
                className="hover:text-blue-400 cursor-pointer"
                onClick={() => navigate(`/${slugify("NAYAPALLI")}`)}
              >
                Girls PG In Nayapalli
              </li>
              <li
                className="hover:text-blue-400 cursor-pointer"
                onClick={() => navigate(`/${slugify("PATIA")}`)}
              >
                Stays in Patia
              </li>
              <li
                className="hover:text-blue-400 cursor-pointer"
                onClick={() => navigate(`/${slugify("KIIT SQUARE")}`)}
              >
                Hostels near KIIT
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PropertyFooter;
